import { ChangePasswordRequest } from 'api/core';
import { useChangePassword } from 'api/useAuthApi';
import { Page } from 'layouts/Admin/Page';
import { useForm } from 'react-hook-form';

export const ProfileView = () => {
  return (
    <Page title="Profil">
      <div className="space-y-2">
        <ChangePassword />
      </div>
    </Page>
  );
};

const ChangePassword = () => {
  const { mutateAsync, isPending } = useChangePassword();

  const { register, handleSubmit, reset } = useForm<
    ChangePasswordRequest & {
      confirmPassword: string;
    }
  >({
    defaultValues: {},
  });

  const onSubmit = handleSubmit(async (result) => {
    try {
      await mutateAsync({ changePasswordRequest: result });
      reset();
    } catch {
      /* empty */
    }
  });

  return (
    <div className="card bg-base-200 p-4 rounded-sm border-gray-300 shadow-md border">
      <div className="card-body">
        <h2 className="card-title">Skift adgangskode</h2>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="form-control">
            <label className="label">
              <span className="text-base label-text">
                Nuværende adgangskode
              </span>
            </label>
            <input
              {...register('currentPassword', { required: true })}
              type="password"
              placeholder="Adgangskode"
              className="w-full input input-bordered"
              minLength={8}
            />
          </div>

          <div className="form-control">
            <label className="label">
              <span className="text-base label-text">Ny adgangskode</span>
            </label>
            <input
              {...register('password', {
                required: true,
              })}
              type="password"
              placeholder="Ny adgangskode"
              className="w-full input input-bordered"
              minLength={8}
            />
          </div>

          <div className="form-control">
            <label className="label">
              <span className="text-base label-text">
                Gentag ny adgangskode
              </span>
            </label>
            <input
              {...register('confirmPassword', {
                required: true,
                validate: (value, formValues) => value === formValues.password,
              })}
              type="password"
              placeholder="Gentag ny adgangskode"
              className="w-full input input-bordered"
              minLength={8}
            />
          </div>
          <div>
            <button className="btn btn-primary btn-block" disabled={isPending}>
              Skift adgangskode
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
